import { http } from '@/utils'

const state = {
  vulnerabilities: [],
  severityCounts: {
    critical: 0,
    high: 0,
    moderate: 0,
    low: 0
  }
}

const getters = {
  uri: (state, getters, rootState) => `applications/${rootState.applications.single.id}/dependencies/vulnerabilities`
}

const actions = {
  async getVulnerabilities ({ commit, getters }, params) {
    const response = await http.get(getters.uri, { params })

    commit('SET_VULNERABILITIES', response.data.data)
    commit('SET_SEVERITY_COUNTS', response.data.meta.vulnerability_severity_counts)
  },

  resetVulnerabilities ({ commit }) {
    commit('SET_VULNERABILITIES', [])
    commit('SET_SEVERITY_COUNTS', {
      critical: 0,
      high: 0,
      moderate: 0,
      low: 0
    })
  }
}

const mutations = {
  SET_VULNERABILITIES (state, vulnerabilities) {
    state.vulnerabilities = vulnerabilities
  },

  SET_SEVERITY_COUNTS (state, severityCounts) {
    state.severityCounts = severityCounts
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
